import "./Loader.css";

const Loader = () => {
  return <div className="loader">loading...</div>;
};

export default Loader;
